import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ValidationError, FormValidator, FormValidationService, ErrorHandlingService } from 'core-lib';
import { ApplicationService, ActivationCodeLookupResponseData, ActivateAccountRequest } from '../services/application.service';

@Component({
  selector: 'cli-application-confirm',
  templateUrl: './application-confirm.component.html',
  styleUrls: ['./application-confirm.component.scss']
})
export class ApplicationConfirmComponent implements OnInit {

  public vm: ApplicationConfirmViewModel;
  private validator: FormValidator;

  constructor(private route: ActivatedRoute,
    private formValidationSvc: FormValidationService,
    private appSvc: ApplicationService,
    private errorHandlingSvc: ErrorHandlingService) {

    this.vm = new ApplicationConfirmViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);
    let activationCode: string = this.route.snapshot.paramMap.get('id');
    let username: string = this.route.snapshot.queryParamMap.get('username');
    let isNoEmail: boolean = this.route.snapshot.queryParamMap.get('email') == 'false';

    this.vm.userName = username;
    this.vm.isNoEmail = isNoEmail;
    this.vm.activationCode = activationCode;
  }

  ngOnInit() {

    this.vm.isOpening = true;
    this.vm.isLoading = true;

    this.appSvc.lookupCode(this.vm.activationCode, this.vm.userName).toPromise().then((data: ActivationCodeLookupResponseData) => {
      this.vm.isOpening = false;
      this.vm.isLoading = false;

      this.vm.exists = data.exists;
      this.vm.isActivated = data.isActivated;
      this.vm.isPasswordSet = data.isPasswordSet;
    },
      (e) => {
        this.vm.isOpening = false;
        this.vm.isLoading = false;
        console.log(e);
      });
  }


  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  validate(vm: ApplicationConfirmViewModel): Promise<void> {
    vm.errors = [];

    this.validator.validateRequired('password', 'Password');
    this.validator.validateRequired('confirmPassword', 'Confirm password');
    this.validator.validateMinLength('password', 'Password', 6);

    this.validator.validateCustom('confirmPassword', 'Passwords do not match', () => {
      return vm.password !== vm.confirmPassword;
    });



    if (vm.errors.length > 0) { return Promise.reject('Invalid Input'); }
    return Promise.resolve();
  }

  public activateAccount() {

    this.validate(this.vm).then(() => {

      let data = new ActivateAccountRequest();
      data.activationCode = this.vm.activationCode;
      data.userName = this.vm.userName;
      data.password = this.vm.password;

      this.vm.isLoading = true;

      return this.appSvc.activateAccount(this.vm.activationCode, data).toPromise()
        .then(() => {

          this.vm.isLoading = false;
          this.vm.isPasswordSet = true;
          this.vm.isActivated = true;
        },
          (e) => {
            this.vm.isLoading = false;
            this.errorHandlingSvc.processHttpError(e);
          });

    },
      (e) => { });
  }
}

class ApplicationConfirmViewModel {

  public isOpening: boolean;
  public isLoading: boolean;

  public userName: string;
  public password: string;
  public confirmPassword: string;
  public activationCode: string;

  public isNoEmail: boolean;

  public exists: boolean;
  public isActivated: boolean;
  public isPasswordSet: boolean;

  public errors: ValidationError[];
}
